import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { CategoryType } from 'sdk/types.d';

import { supabase } from '../api';

const getCategories = async (playlistId: number): Promise<CategoryType[]> => {
  const { data, error }: PostgrestSingleResponse<any[]> = await supabase
    .from('playlists_categories')
    .select(`*, 
    categories:categories!category_id!inner (*)
    `)
    .eq('playlist_id', playlistId)

  if (error) {
    throw new Error(error.message);
  }

  return data.map((d) => d.categories);
};

export default function useCategoriesByPlailist(playlistId = 0) {
  return useQuery({
    queryKey: ['useCategoriesByPlailist'],
    queryFn: () => getCategories(playlistId),
    staleTime: 0,
    cacheTime: 0,
  });
}
